export const environment = {
  api_redsys: 'https://dev.restaurantedonchon.com',
  url: '/api/',
  GOOGLE_ID: '',
};
